/**
 * @file enterKey.js
 * @version 1.0.0
 * @author Cam Seymour
 * @project Excel Agri System
 * @created 2026-10-01
 * @modified 2026-10-01
 * @description "Enter means search now" — the one key check behind it.
 *
 *              A search box searches as you type, after a pause, and Enter is
 *              what people press when they want it NOW. The boxes sit in no
 *              <form>, so Enter did nothing until each was given a handler.
 *              `Input`'s `onEnter` prop uses this; so do the few search boxes
 *              that are plain <input>s styled by their screen (Payments'
 *              filter row, Contact Groups' search box), where swapping in
 *              `Input` would change how the box looks.
 */

/**
 * True for an Enter keydown that should act: not while an IME is composing
 * (Enter there picks the candidate — keyCode 229 is how some browsers report
 * it), and not when an earlier handler has already dealt with the key.
 */
export function isActionEnter(e) {
  if (!e || e.key !== 'Enter' || e.defaultPrevented) return false;
  if (e.nativeEvent?.isComposing || e.isComposing || e.keyCode === 229) return false;
  return true;
}

/**
 * An onKeyDown handler that runs `handler(e)` on such an Enter, after
 * preventing the default (so a box inside a <form> does not also submit it).
 */
export function onEnterKey(handler) {
  return (e) => {
    if (typeof handler !== 'function' || !isActionEnter(e)) return;
    e.preventDefault();
    handler(e);
  };
}

export default onEnterKey;
